import { Component, OnInit, ElementRef, AfterViewInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { FormControl, FormGroup } from '@angular/forms';
import { AuthService } from './services/auth.service';
import { LoadingService } from './services/loading.service';
import { SidenavService } from './services/sidenav.service';
import { HttpService } from './services/http.service';
import { ReCaptchaService } from './services/recaptcha.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewInit {
    constructor(
        public loading: LoadingService,
        public sidenav: SidenavService,
        private http: HttpService,
        private el: ElementRef,
        public auth: AuthService,
        private title: Title,
        private recaptcha: ReCaptchaService
    ) {
    }

    loginForm = new FormGroup({
        password: new FormControl(null),
    });
    userEmail: string | null = null;
    userData = this.auth.userData || {};

    isLoggedIn(): boolean {
        return this.auth.isLoggedIn();
    }

    submitLogin(form: FormGroup): void {
        if (!form.valid) {
            this.el.nativeElement.querySelectorAll('.auth-form [formcontrolname].ng-invalid')[0]?.focus();
            return;
        }
        let fdata = new FormData();
        fdata.append('password', form.value?.password);
        form.disable();
        this.http.Post('auth/refresh', fdata).then((r: any) => {
            form.enable();
            if (r.success) {
                form.reset();
                const data = r?.response?.result || {};
                this.auth.refreshTimeout(data);
            } else {
                if (r.response && r.response.wrong) {
                    Object.keys(r.response.wrong).forEach((key) => {
                        form.get(key)?.setErrors({ serverError: r.response.wrong[key][0] });
                        this.el.nativeElement.querySelectorAll('.auth-form [formcontrolname="' + key + '"]')?.[0]?.focus();
                    });
                }
            }
        });
    }

    authLogout(): void {
        this.auth.logout(false, true);
    }

    async ngOnInit(): Promise<void> {
        if (this.isLoggedIn()) {
            this.title.setTitle('Home | MFGM - CMS');
        } else {
            this.title.setTitle('Login | MFGM - CMS');
        }

        this.el.nativeElement.removeAttribute("ng-version");

        (document as any).fonts.ready.then(() => {
            document.documentElement.classList.add('fonts-loaded');
        });

        this.recaptcha.loadScriptIfNeeded();
    }

    ngAfterViewInit(): void {
        const authData = this.auth.userData;
        this.userEmail = authData?.email;
    }
}
